import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useScreen } from 'Screen/ScreenContext';
import api from '@helpers/api';

export function useChargebackLogs(communityId, userId) {
    const { t } = useTranslation('banking');
    const { setSnackbar } = useScreen();

    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ pages: 0, records: 0, page: 1 });

    useEffect(() => {
        if (communityId && userId) {
            fetchLogs(1);
        }
    }, [communityId, userId]);

    async function fetchLogs(page = 1) {
        if (!communityId || !userId) return;
        try {
            setLoading(true);
            const { data } = await api.get(
                `community/${communityId}/logs/list?filters[user_id]=${userId}&orderby[id]=desc&page=${page}&per_page=50`
            );
            setLogs(data.data ?? []);
            setPagination({
                pages: data.pages ?? 0,
                records: data.records ?? 0,
                page: data.page ?? 1,
            });
        } catch (e) {
            console.error(e);
            setLogs([]);
            setPagination({ pages: 0, records: 0, page: 1 });
        } finally {
            setLoading(false);
        }
    }

    async function exportLogs() {
        if (!communityId || !userId) return;
        const { data } = await api.post(
            `community/${communityId}/logs/export?filters[user_id]=${userId}&orderby[id]=desc`
        );
        setSnackbar(t('chargebacks.logs.exportStarted', { email: data.email }));
    }

    return { logs, loading, pagination, fetchLogs, exportLogs };
}
